import axios from 'axios';
import track from './track';
import config from '@config';

// 师资签名引入
const sigenature = new service.ZmCrypto.Sigenature();

const instance = axios.create({
  // 前端超时时间
  timeout: 1000 * 30,

  // 表示跨域请求时是否需要使用凭证
  // withCredentials: true,


  // 默认是 ajax 异步请求
  // headers: {
  //   'X-Requested-With': 'XMLHttpRequest',
  //   'Accept-Encoding': 'gzip, deflate',
  // },

  baseURL: `${config.apiHost}`,
  // baseURL: `${host}/api`,
  // timeout: 600000,
  // xsrfCookieName: 'ctoken',
  // xsrfHeaderName: 'x-csrf-token',
});

// 配置请求拦截器，支持请求参数isCustomProcessing，表示自定义响应处理
instance.interceptors.request.use(req => {
  const params = req.method === 'post' ? req.data : req.params;
  if (params.hasOwnProperty('customHeaders')) {
    const headers = params.customHeaders;
    const keys = Object.keys(headers);
    keys.forEach(key => {
      req.headers[key] = headers[key];
    });
    delete params.customHeaders;
  }

  // 请求参数存在isCustomProcessing时的处理
  if (params.isCustomProcessing) {
    // isCustomProcessing参数用完删除，不要传递给后端
    delete params.isCustomProcessing;

    // 把对isCustomProcessing的处理方法加到transformResponse里去
    if (Array.isArray(req.transformResponse)) {
      req.transformResponse = req.transformResponse.concat([
        result => {
          if (result) {
            result.isCustomProcessing = true;
          }
          return result;
        },
      ]);
    }
  }

  // 添加签名处理
  if (params._sign === true) {
    delete params._sign;
    params.sign = sigenature.sigenature(params);
  }

  return req;
});

// 配置接口响应拦截器
instance.interceptors.response.use(
  response => {
    // 响应结果
    const result = response.data || {};

    // 是否使用自定义处理，可在请求参数里设置
    if (result.isCustomProcessing) {
      return result;
    }

    // 请求配置
    const conf = response.config || {};

    // 是否异常
    let isException = false;

    // 是否采用默认异常处理
    let isDefaultExceptionProcess = true;

    // 取消默认异常处理
    const cancelDefaultExceptionPrecess = () => {
      isDefaultExceptionProcess = false;
    };
    // console.log(result, '>>>result')
    // 根据新老接口一般规则判断是否异常，不符合这个规则的可以在请求的时候添加isCustomProcessing:true参数，自行处理返回结果
    if (
      (result.msgCode !== undefined && result.msgCode != '200') ||
      ((result.code != '0' && result.code != '200' && result.code != '0000') && result.message !== undefined)
    ) {
      isException = true;
    }

    // 滞后执行，可通过调用cancelDefaultExceptionPrecess方法拦截
    setTimeout(() => {
      if (!isDefaultExceptionProcess) return;

      // 新老接口异常判断
      if (isException) {
        track.reportApiException({
          url: conf.url,
          data: result,
          params: conf.params,
        });
      }
    }, 0);

    if (isException) {
      // 如果异常，则返回完整的响应信息，并提供撤销默认异常处理的方法，可允许业务端自行处理异常
      /* eslint-disable */
      return Promise.reject({ ...result, cancelDefaultExceptionPrecess });
    } else {
      return result.data;
    }
  },
  error => {
    // 请求配置信息
    const response = error.response || {};
    const config = response.config || {};

    // 是否采用默认异常处理
    let isDefaultExceptionProcess = true;
    const cancelDefaultExceptionPrecess = () => {
      isDefaultExceptionProcess = false;
    };

    // 滞后执行，可通过调用cancelDefaultExceptionPrecess方法拦截
    setTimeout(() => {
      if (isDefaultExceptionProcess) {
        track.reportApiException({
          url: config.url,
          params: config.params,
          data: response.data,
        });
      }
    }, 0);

    return Promise.reject({ ...error, cancelDefaultExceptionPrecess });
  }
);

export default instance;
